export enum MonitorTab {
  ACTIVITIES = 'monitors/activities',
  CALL_CENTER = 'monitors/call-center',
  CHANNELS = 'monitors/channels',
  AGENTS = 'monitors/agents',
  CALL_MONITOR = 'monitors/call-monitor',
}
export const MonitorTabList = [
  {
    id: MonitorTab.ACTIVITIES,
    icon: 'fa fa-tasks',
    title: 'Hoạt động trong ngày',
  },
  {
    id: MonitorTab.CALL_CENTER,
    icon: 'fa fa-inbox',
    title: 'Tổng đài',
  },
  {
    id: MonitorTab.CHANNELS,
    icon: 'fa fa-television',
    title: 'Đa kênh',
  },
  {
    id: MonitorTab.AGENTS,
    icon: 'fa fa-user',
    title: 'Chuyên viên',
  },
  {
    id: MonitorTab.CALL_MONITOR,
    icon: 'fa fa-volume-control-phone',
    title: 'Giám sát cuộc gọi',
  },
];
export function getCurrentTab(url) {
  let tab = '';
  Object.keys(MonitorTab).forEach(s => {
    if (url.includes(MonitorTab[s])) {
      tab = MonitorTab[s];
    }
  });
  return tab;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/monitors/monitors.const.ts